import { useEffect, type ReactNode } from 'react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

/** Logs Homestead build version and git commit once when the app root mounts. */
export function BuildInfoLogger({ children }: { children: ReactNode }) {
  const config = useApi(configApiRef);

  useEffect(() => {
    const version =
      config.getOptionalString('homestead.buildInfo.version') ?? 'unknown';
    const commit =
      config.getOptionalString('homestead.buildInfo.commit') ?? 'unknown';
    // eslint-disable-next-line no-console
    console.log(`Homestead version=${version} commit=${commit}`);
  }, [config]);

  return <>{children}</>;
}
